import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Clothes } from '../models/Clothes';
import { DataClothes } from '../models/DataClothes';
import { Family } from '../models/Family';
import { UseConditions } from '../models/UseConditions';
import { CONSTANTES } from '../shared/global';

@Injectable({
  providedIn: 'root'
})
export class ClothesService {

  public url: string;

    constructor(private http: HttpClient) {
        this.url = CONSTANTES.api_url + "/clothes";
    }

    getClothes(){
      const iheaders = new HttpHeaders().set('Content-Type', 'application/json');
      return this.http.get<DataClothes>(this.url + "/all", { headers: iheaders });
    }

    getClothesWithoutData(){
      const iheaders = new HttpHeaders().set('Content-Type', 'application/json');
      return this.http.get<DataClothes>(this.url + "/allWithoutData", { headers: iheaders });
    }

    getStockOut(){
      const iheaders = new HttpHeaders().set('Content-Type', 'application/json');
      return this.http.get<DataClothes>(this.url + "/stock", { headers: iheaders });
    }

    getDetailStockOut(){
      const iheaders = new HttpHeaders().set('Content-Type', 'application/json');
      return this.http.get<DataClothes>(this.url + "/detailstock", { headers: iheaders });
    }

    saveClothes(datos: Clothes){
      const iheaders = new HttpHeaders().set('Content-Type', 'application/json');
      return this.http.post<DataClothes>(this.url + "/save", JSON.stringify(datos),{ headers: iheaders });  
    }

    saveNocs(datos: Clothes){
      const iheaders = new HttpHeaders().set('Content-Type', 'application/json');
      return this.http.post<DataClothes>(this.url + "/saveNocs", JSON.stringify(datos),{ headers: iheaders });  
    }

    getClothesByFamily(family: Family){
      const iheaders = new HttpHeaders().set('Content-Type', 'application/json');
      return this.http.post<DataClothes>(this.url + "/family", JSON.stringify(family), { headers: iheaders });
    }

    getVisibleClothesByFamily(family: Family){
      const iheaders = new HttpHeaders().set('Content-Type', 'application/json');
      return this.http.post<DataClothes>(this.url + "/familyVisible", JSON.stringify(family), { headers: iheaders });
    }

    getClothById(id: number){
      const iheaders = new HttpHeaders().set('Content-Type', 'application/json');
      return this.http.post<DataClothes>(this.url + "/getClothById", id, { headers: iheaders });
    }

    getClothByCode(code: string){
      const iheaders = new HttpHeaders().set('Content-Type', 'application/json');
      return this.http.post<Clothes>(this.url + "/getClothByCode", code, { headers: iheaders });
    }

    getVisibleAndInvisibleClothesWithoutData(){
      const iheaders = new HttpHeaders().set('Content-Type', 'application/json');
      return this.http.get<DataClothes>(this.url + "/allClothesWithoutData", { headers: iheaders });
    }

    /**
     * Obtiene los articulos unicamente con el objeto Nocsize que contiene las tallas
     * @returns 
     */
    getClothesWithNocSizes(){
      const iheaders = new HttpHeaders().set('Content-Type', 'application/json');
      return this.http.get<DataClothes>(this.url + "/allClothesWithNocSizes", { headers: iheaders });
    }

    /**
     * Obtiene el NocSize buscado por codigo interno o noc
     * @param searchedCode 
     * @returns 
     */
    getNocSizeByNocOrInternalCode(searchedCode: string){
      const iheaders = new HttpHeaders().set('Content-Type', 'application/json');
      return this.http.post<DataClothes>(this.url + "/nocSizeByNocOrInternalCode", JSON.stringify(searchedCode), { headers: iheaders });
    }

    /**
     * Obtiene el articulo con todos sus datos, incluyendo las condiciones de uso
     * @param cloth 
     * @returns 
     */
    getUseConditionsByCloth(cloth: Clothes){
      const iheaders = new HttpHeaders().set('Content-Type', 'application/json');
      return this.http.post<DataClothes>(this.url + "/useConditionsByCloth", JSON.stringify(cloth), { headers: iheaders });
    }

    /**
     * Guarda una nueva condicion de uso en la bbdd
     * @param useCondition
     * @returns 
     */
    saveNewUseCondition(useCondition: UseConditions){
      const iheaders = new HttpHeaders().set('Content-Type', 'application/json');
      return this.http.post<DataClothes>(this.url + "/saveUseCondition", JSON.stringify(useCondition), { headers: iheaders });
    }

    /**
     * Obtiene todas las condiciones de uso guardadas en la bbdd
     * @returns 
     */
    getAllUsesConditions(){
      const iheaders = new HttpHeaders().set('Content-Type', 'application/json');
      return this.http.post<DataClothes>(this.url + "/getAllUseConditions", { headers: iheaders });
    }

    /**
     * Actualiza las condiciones de uso de un usuario
     */
    updateItemUseCondition(dataClothes: DataClothes){
      const iheaders = new HttpHeaders().set('Content-Type', 'application/json');
      return this.http.post<DataClothes>(this.url + "/updateItemUseCondition", JSON.stringify(dataClothes), { headers: iheaders });
    }
    
    /**
     * Obtiene el NocSize para una cinta, buscado por ribbon, job, weapon y staff
     * @param  
     * @returns 
     */
    getNocSizeByObservations(dataCloth: DataClothes){
      const iheaders = new HttpHeaders().set('Content-Type', 'application/json');
      return this.http.post<DataClothes>(this.url + "/nocSizeByObservations", JSON.stringify(dataCloth), { headers: iheaders });
    }

    /**
     * Trae solo las prendas visibles con todas sus relaciones
     * @returns
     */
    getAllVisibleClothes(){
      const iheaders = new HttpHeaders().set('Content-Type', 'application/json');
      return this.http.get<DataClothes>(this.url + "/allVisible", { headers: iheaders });
    }

}
